import React from "react";
import { Container, Menu } from "semantic-ui-react";
import Login from "login/components/Login";
import { Switch, Route, Redirect } from "react-router-dom";

const UnauthenticatedApp = ({ onLogin }) => {
  return (
    <Container>
      <>
        <Menu pointing secondary>
          <Menu.Item header>Accessible Doc Gen</Menu.Item>
        </Menu>
        <Login onLoginClicked={onLogin}></Login>
      </>
      <Switch>
        <Route exact path="/login" />
        <Redirect to="/login" />
      </Switch>
    </Container>
  );
};

export default UnauthenticatedApp;
